import React, {useRef, useState} from 'react';
import './ProfileMedia.scss';
import {generateMediaUrl} from "../../../../utils/generateMediaUrl";
import {PersonBoxIcon} from "../../../../image";
import {Text} from "../../../index";
import {useTranslation} from "react-i18next";
import {hasPermission} from "../../../../utils/helperFunctions";
import {ROLE_ITEMS} from "../../../../utils/constants";
import classNames from "classnames";

function ProfileMedia(props) {
	const {personById} = props;
	const [file, setFile] = useState(null)
	const uploadImg = useRef();
	const {t} = useTranslation();
	const isCheckPermissionEditPhoto =  hasPermission(ROLE_ITEMS.FOREIGN_USERS_PROFILE_PERSONAL_EDIT);

	function readFile(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = function(e) {
				let dataURL = e.target.result;
				resolve(dataURL);
			};
			reader.onerror = function(e) {
				reject(e);
			};
			reader.readAsDataURL(file);
		});
	}

	function handleImageChange(e) {
		let file = e?.target?.files[0];
		readFile(file)
			.then(dataURL => {
				setFile(dataURL)
			});
	}

	function scrollToAndClickProfilePhotoAccordion() {
		const element = document.querySelector('.profile-photo-accordion .accordion-button');

		if (element) {
			element.scrollIntoView({ behavior: 'smooth', block: 'center' });

			// Ждём окончания скролла (примерно 500 мс) и кликаем
			element.click();
		} else {
			console.warn('Элемент .profile-photo-accordion не найден');
		}
	}

	return (
		<div
			className={
				classNames(
					'profile-media',
					{
						'profile-media--photo': isCheckPermissionEditPhoto
					}
				)}
			onClick={isCheckPermissionEditPhoto ? scrollToAndClickProfilePhotoAccordion : null}>
			<img
				src={file ? file : generateMediaUrl(personById?.avatar)}
				alt=""
			/>
			<div className="profile-media__edit">
				<PersonBoxIcon/>
				<Text size="f12" font="medium" color="#1ABB78">{t('edit_avatar')}</Text>
			</div>
		</div>
	)
}

export default ProfileMedia;
